import initCart from '@sectionsJS/cart';

$(async () => {
  initCart();
});
